/**
 * mad-video — responsive control positions for the minimal player.
 *
 * Each control's "Position" select writes --mad-video-pos per Bricks breakpoint
 * (top-left … bottom-right or hidden). We read the value the browser resolved for the
 * current viewport and move the control into the matching slot — so positions follow
 * Bricks' breakpoints without knowing how Bricks stores them.
 */

// Fixed order, so controls sharing a slot always line up the same way
var ORDER = ['play', 'sound', 'fullscreen', 'progress'];

var isBuilder = window.location.href.indexOf('brickspreview') !== -1;

function applySlots(ui) {
  ORDER.forEach(function (name) {
    var ctrl = ui.querySelector('.mad-video__ctrl--' + name);
    if (!ctrl) return;

    var pos = getComputedStyle(ctrl).getPropertyValue('--mad-video-pos').trim() || ctrl.dataset.defaultPos;

    ctrl.hidden = pos === 'hidden'; // also un-hides when a breakpoint switches back
    if (ctrl.hidden) return;

    // The progress bar runs along an edge (top / bottom), the others sit in a slot
    var slot = name === 'progress'
      ? ui.querySelector('.mad-video__edge--' + pos)
      : ui.querySelector('.mad-video__slot--' + pos);
    if (!slot) return; // unknown value: leave the control where it is

    slot.appendChild(ctrl); // appending in ORDER keeps a stable order per slot
    ctrl.dataset.slotRow = pos.indexOf('top') === 0 ? 'top' : 'bottom'; // vertical volume opens away from the edge
  });
}

function applyAll() {
  document.querySelectorAll('.mad-video__ui').forEach(applySlots);
}

// One global listener set (not per instance): the builder re-renders elements as new
// nodes, so per-instance listeners would pile up on detached elements.
var frame = 0;
function schedule() {
  cancelAnimationFrame(frame);
  frame = requestAnimationFrame(applyAll);
}

// Width only: the mobile address bar fires height-only resizes while scrolling
var lastWidth = window.innerWidth;
window.addEventListener('resize', function () {
  if (window.innerWidth === lastWidth) return;
  lastWidth = window.innerWidth;
  schedule();
});

// Builder: changing a position only swaps Bricks' generated CSS (no re-render, no
// setupMadVideo call), so re-slot whenever a <style> element changes.
function isStyle(node) {
  return node && node.nodeName === 'STYLE';
}

if (isBuilder && 'MutationObserver' in window) {
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      var target = m.target.nodeType === 3 ? m.target.parentNode : m.target;
      if (isStyle(target) || [].some.call(m.addedNodes, isStyle) || [].some.call(m.removedNodes, isStyle)) {
        schedule();
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, characterData: true, subtree: true });
}

module.exports = { applyAll: applyAll, isBuilder: isBuilder };
